import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-platinum-notification',
  imports: [CommonModule, TranslateModule],
  templateUrl: './platinum-notification.component.html',
  styleUrl: './platinum-notification.component.scss'
})
export class PlatinumNotificationComponent {
  @Input() platinumMember: any = null;
  @Input() targetApplicationCount: number = 0;
  @Input() totalApplications: number = 0;
  @Output() viewBenefits = new EventEmitter<void>();

  get showNotification(): boolean {
    return !!this.platinumMember && this.platinumMember?.isPlatinumAccount !== 'Yes';
  }

  get applicationPercentage(): number {
    if (!this.targetApplicationCount || this.targetApplicationCount <= 0) {
      return 0;
    }
    const percentage = (this.totalApplications / this.targetApplicationCount) * 100;
    return Math.max(0, Math.min(100, Number(percentage.toFixed(2))));
  }

  onViewBenefits(): void {
    this.viewBenefits.emit();
  }
}
